import MutateFacility from "./MutateFacility";

export default MutateFacility